import { UrlSegments } from '../app/Helpers';
import { WaitForElementToDisplay } from '../app/Helpers/WaitForElementToDisplay';
import { SearchResultsEvent } from '../app/Services/DataLayer';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { CategoryContainer } from '../app/Components/Product/CategoryContainer';
import { ProductPage } from '../app/Components/Product/ProductPage';

let root = UrlSegments(0);

interface QAEntries {
    A_from: string;
    Answer: string;
    Q_from: string;
    Question: string;
}

export const ProductRoutes = new Promise(() => {
    let isSearchParams = window.location.pathname === "/Search";

    if (root === "products" && UrlSegments(1) !== "details" && UrlSegments().length === 3
        || root === "products" && UrlSegments().length === 1) {
        import('../app/ViewModels/Products/Sections' /* webpackChunkName: "product-sections" */).then(() => {
            WaitForElementToDisplay(".image-rows", 300, () => {
                document.querySelector('.image-rows').removeAttribute('hidden');
            });
        });
    }

    if (!UrlSegments(0) || !UrlSegments(1)) {
        if (!isSearchParams) {
            console.debug("Not a product route");
            return;
        }
    }

    let section = "";

    if (UrlSegments(1)) {
        section = UrlSegments(1).toString();
    }

    let isDetails = false;
    let isCategory = false;
    let isSection = false;
    let isSearchResults = root === "Search";

    if (isSearchParams) {
        isSearchResults = true;
    }

    // Check what kind of product page we're on  
    if (root === "products" && UrlSegments().length >= 2) {

        if (UrlSegments(1) === "details") {
            isDetails = true;
        }

        //sections have this path: products/{section-slug}/{id}/
        if (UrlSegments().length == 3) {
            isSection = true;
        }

        //categories have this path:products/{section-slug}/{category-slug}/{id}/
        if (!isDetails && !isSection) {

            let tail = UrlSegments(2);
            if (isNaN(+tail)) {
                isCategory = true;
            }
        }
    }

    let promoCategory = [
        "on-sale",
        "new-products"
    ];

    let isPromo = promoCategory.indexOf(section) != -1;

    console.debug("Product route values: ", { isDetails, isCategory, isPromo, isSearchResults, isSection });

    //search, categories and promotion view pages are the same file
    if (isCategory || isPromo || isSearchResults) {
        import('../app/ViewModels/Products/CategoryGroup' /* webpackChunkName: "category-group" */).then((viewModel) => {
            //document.querySelector('.image-rows').removeAttribute('hidden');
            WaitForElementToDisplay(".image-rows", 300, () => {
                document.querySelector('.image-rows').removeAttribute('hidden');
            });
            WaitForElementToDisplay("#category-items-loop", 300, () => {
                const root = ReactDOM.createRoot(document.querySelector("#category-items-loop"));
                root.render(<CategoryContainer />);
            });

            console.group("Initializing Category Group VM...")
            const vm = new viewModel.CategoryVM();
            window.vm = vm;

            WaitForElementToDisplay("#category-group", 300, () => {
                ko.applyBindings(vm, document.getElementById('category-group'))
            });
            console.info("Category Group VM bound");
            console.groupEnd();

            // Search Results GA Events
            if (isSearchResults) {
                let dataLayerEvent = new SearchResultsEvent();
                dataLayerEvent.event = "searchResults";

                let path = window.location
                let params = new URLSearchParams(path.search);
                let keyword = params.get('keyword');
                if (keyword) {
                    console.log("Search term: ", keyword);
                    dataLayerEvent.dimension6 = keyword;

                } else {
                    keyword = UrlSegments(1).toString();
                    console.log("Search term: ", keyword);
                    dataLayerEvent.dimension6 = keyword;
                }

                let results = !!window.Model.itemGroupModel ? window.Model.itemGroupModel : window.Model;

                if (results.length > 0) {
                    dataLayerEvent.dimension5 = results.length;
                    dataLayerEvent.eventLabel = "Search keyword - " + keyword + " - returned " + results.length + " results";

                } else {
                    dataLayerEvent.dimension5 = 0;
                    dataLayerEvent.eventLabel = "Search keyword - " + keyword + " - returned no results";
                }

                console.debug("SearchResultsEvent: ", dataLayerEvent);

                window.dataLayer.push(dataLayerEvent);

                $(() => {
                    if (!dataLayerEvent.dimension5) {
                        $('#null-results').show();
                    }

                })

                $(() => {
                    // Set up event listener to track clicks
                    $('.product > a').each((i, el) => {

                        let data = [];

                        $(el).parent('.product').find('meta').each((idx, elem) => {
                            let prop = $(elem).attr('content');
                            data.push(prop);
                        })

                        let item = {
                            "IGRN": data[0],
                            "Product Group": data[3],
                            "Manufacturer": data[1]
                        }

                        let clickEvent = new SearchResultsEvent();
                        clickEvent.event = "searchResults";
                        clickEvent.eventLabel = dataLayerEvent.eventLabel;
                        clickEvent.dimension7 = item["Product Group"] + ", IGRN: " + item.IGRN;
                        clickEvent.dimension5 = dataLayerEvent.dimension5;
                        clickEvent.dimension6 = dataLayerEvent.dimension6;

                        $(el).click(() => {
                            console.debug(clickEvent);
                            window.dataLayer.push(clickEvent);
                        });
                    })

                })
            }

        });
    }

    if (isSection == true) {
        import('../app/ViewModels/Products/SectionGroup' /* webpackChunkName: "category-group" */).then((viewModel) => {
            //document.querySelector('.image-rows').removeAttribute('hidden');
            WaitForElementToDisplay(".image-rows", 300, () => {
                document.querySelector('.image-rows').removeAttribute('hidden');
            });

            console.group("Initializing Section Group VM...")
            const vm = new viewModel.SectionVM();
            window.vm = vm;

            WaitForElementToDisplay("#category-group", 300, () => {
                ko.applyBindings(vm, document.getElementById('category-group'))
            });

            WaitForElementToDisplay("#carousel-inner", 300, () => {
                ko.applyBindings(vm, document.getElementById('carousel-inner'))
            });

            console.info("Category Group VM bound");
            console.groupEnd();

            // Search Results GA Events
            if (isSearchResults) {
                let dataLayerEvent = new SearchResultsEvent();
                dataLayerEvent.event = "searchResults";

                let path = window.location
                let params = new URLSearchParams(path.search);
                let keyword = params.get('keyword');
                if (keyword) {
                    console.log("Search term: ", keyword);
                    dataLayerEvent.dimension6 = keyword;

                } else {
                    keyword = UrlSegments(1).toString();
                    console.log("Search term: ", keyword);
                    dataLayerEvent.dimension6 = keyword;
                }

                let results = window.Model[0].Value;

                if (results.length > 0) {
                    dataLayerEvent.dimension5 = results.length;
                    dataLayerEvent.eventLabel = "Search keyword - " + keyword + " - returned " + results.length + " results";

                } else {
                    dataLayerEvent.dimension5 = 0;
                    dataLayerEvent.eventLabel = "Search keyword - " + keyword + " - returned no results";
                }

                console.debug("SearchResultsEvent: ", dataLayerEvent);

                window.dataLayer.push(dataLayerEvent);

                $(() => {
                    if (!dataLayerEvent.dimension5) {
                        $('#null-results').show();
                    }

                })

                $(() => {
                    // Set up event listener to track clicks
                    $('.product > a').each((i, el) => {

                        let data = [];

                        $(el).parent('.product').find('meta').each((idx, elem) => {
                            let prop = $(elem).attr('content');
                            data.push(prop);
                        })

                        let item = {
                            "IGRN": data[0],
                            "Product Group": data[3],
                            "Manufacturer": data[1]
                        }

                        let clickEvent = new SearchResultsEvent();
                        clickEvent.event = "searchResults";
                        clickEvent.eventLabel = dataLayerEvent.eventLabel;
                        clickEvent.dimension7 = item["Product Group"] + ", IGRN: " + item.IGRN;
                        clickEvent.dimension5 = dataLayerEvent.dimension5;
                        clickEvent.dimension6 = dataLayerEvent.dimension6;

                        $(el).click(() => {
                            console.debug(clickEvent);
                            window.dataLayer.push(clickEvent);
                        });
                    })

                })
            }

        });
    }
    if (isDetails) {
        import('../app/ViewModels/Products/ItemGroup' /* webpackChunkName: "item-group" */).then((viewModel) => {

            WaitForElementToDisplay(".similar-products-slider", 300, () => {
                var showElems = document.querySelectorAll('.similar-products-slider');
                for (var i = 0; i < showElems.length; i++) {
                    showElems[i].removeAttribute('hidden');
                }
            });
            let model = window.Model;

            window.addEventListener('load', () => {
                WaitForElementToDisplay("#product-Container", 200, () => {
                    const root = ReactDOM.createRoot(document.querySelector("#product-Container"));
                    root.render(<ProductPage />);
                });
            });

            function ProductLink(el) {
                return "/products/details/" + el.dataset.id + "/" //+ Slugify(el.dataset.heading) + "/";
            }
        });
    }
});